<template>
  <div class="tip-container" @click="handleClose">
    <div class="box" :style="currentStyle" @click.stop>
      <div v-if="data === -1" class="info">
        狩月人您好：
        非常遗憾，您本次未获得测试资格。不过，没关系的！接下来还有更多二重螺旋的精彩内容会在官方企微进行发布，请随时关注【草莓皎皎】官方企微动态，一切资讯尽在掌握！
      </div>
      <div v-else class="info">
        狩月人您好：
        恭喜您，已经成功获得「狩夜测试」资格！预下载将在2月17日12:00开放，下载链接请查看短信或者邮件。新的旅程即将开始，请随时关注【草莓皎皎】官方企微，一切资讯尽在掌握！
      </div>
      <!-- <div class="content">
        <span class="tip">{{ data }}</span>
      </div> -->
      <!-- <van-button class="copy-btn" block type="primary" @click="handleCopy">
        复制
      </van-button> -->
      <van-icon
        class="close-icon"
        size="35"
        color="#f5f5f5"
        name="close"
        @click="handleClose"
      />
    </div>
  </div>
</template>
<script>
import dayjs from "dayjs";
import { px2rem, copyText } from "@/utils/util";
import { Toast } from "vant";
// import Cookies from "js-cookie";

export default {
  props: {
    data: {
      type: Number,
      default: -1,
    },
  },
  data() {
    return {
      checked: undefined,
      currentStyle: {
        width: px2rem(628),
        height: px2rem(400),
      },
    };
  },
  mounted() {
    // 获取屏幕高度和高度，如何宽度大于高度，图片高度需要小一点
    const width = window.innerWidth;
    const height = window.innerHeight;
    if (width > height) {
      this.currentStyle.width = "auto";
      this.currentStyle.height = "60%";
    }
  },
  methods: {
    handleClose() {
      this.$emit("close");
    },
    handleCopy() {
      copyText(this.data).then(() => {
        Toast("复制成功");
      });
    },
  },
};
</script>
<style lang="less" scoped>
.tip-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.4);
  .box {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    position: relative;
    padding: 10px;
    background: #ffffff;
    border-radius: 10px 10px 10px 10px;
    box-sizing: border-box;
    .info {
      font-size: 16px;
      color: #4b4b4b;
      text-align: center;
    }
    .content {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      // height: 100%;
      padding: 10px 22px;
      border-radius: 10px 10px 10px 10px;
      border: 1px solid rgba(214, 187, 138, 0.42);
      box-sizing: border-box;
      .tip {
        font-weight: 400;
        font-size: 16px;
        color: #4b4b4b;
        line-height: 16px;
        word-break: break-all;
      }
    }
    .copy-btn {
      width: 200px;
    }
    .close-icon {
      position: absolute;
      bottom: -40px;
      left: 50%;
      transform: translateX(-50%);
    }
  }
}
</style>
